<div class="shell-layout">
  <div class="shell-body">
    @if (!isMobile) {
      <aside class="shell-sidenav">
        <app-side-nav
          [items]="resolvedNavItems"
          [mobile]="false"
          [roleOptions]="roleOptions"
          [activeRole]="activeRole"
          [roleLabel]="getActiveRoleLabel()"
          [sectionLabel]="getSideNavSectionLabel()"
          [brandTitle]="getSideNavBrandTitle()"
          [version]="version"
          (roleChange)="onRoleChange($event)"
          (groupToggle)="onSideNavGroupToggle($event)"
          (navigate)="onSideNavNavigate()"
        ></app-side-nav>
      </aside>
    }

    <main class="main-content">
      @if (isMobile) {
        <div class="mobile-nav-trigger">
          <p-button
            icon="pi pi-bars"
            severity="secondary"
            [text]="true"
            [rounded]="true"
            [ariaLabel]="getSideNavSectionLabel()"
            (onClick)="toggleDrawer()"
          ></p-button>
        </div>
      }

      @if (showPageHeader) {
        <header class="page-header">
          @if (departmentContextName) {
            <p class="page-header-context">{{ departmentContextName }}</p>
          }
          <h1 class="page-header-title">{{ pageHeaderTitle }}</h1>
        </header>
      }

      <section
        class="page-content"
        [class.with-page-header]="showPageHeader"
        [class.compact-header-spacing]="compactPageHeaderSpacing"
      >
        <router-outlet></router-outlet>
      </section>
    </main>
  </div>
</div>

<p-drawer
  [(visible)]="isDrawerVisible"
  position="left"
  [modal]="true"
  [dismissible]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  [showCloseIcon]="true"
  (onHide)="closeDrawer()"
  [header]="portalHeader"
  styleClass="shell-drawer"
  [style]="{ width: '18rem' }"
>
  <app-side-nav
    [items]="resolvedNavItems"
    [mobile]="true"
    [roleOptions]="roleOptions"
    [activeRole]="activeRole"
    [roleLabel]="getActiveRoleLabel()"
    [sectionLabel]="getSideNavSectionLabel()"
    [brandTitle]="getSideNavBrandTitle()"
    [version]="version"
    (roleChange)="onRoleChange($event)"
    (groupToggle)="onSideNavGroupToggle($event)"
    (navigate)="onSideNavNavigate()"
  ></app-side-nav>
</p-drawer>
